import { ReactNode } from 'react';
import { InputLabel } from '@mui/material';

const CustomInputLabel = ({ children }: { children: ReactNode }) => (
  <InputLabel sx={{ marginBottom: '5px' }}>{children}</InputLabel>
);
export default CustomInputLabel;
